function base64(text: string): string {
  const uint8Array = new TextEncoder().encode(text);
  // Uint8Array.prototype.toBase64() is not available
  const binString = String.fromCodePoint(...uint8Array);
  return 'data:text/plain;base64,' + btoa(binString);
}

export function base64IfNeeded(text: string) {
  const regex = /^[\u0020-\u007e]*$/;
  if (regex.test(text)) {
    return text;
  }

  return base64(text);
}
